document.addEventListener("DOMContentLoaded", () => {
	const signupForms = document.querySelectorAll("form.signup-form");
	const profileForm = document.querySelectorAll("form.profile-form");

	signupForms.forEach((form) => {
        const professionField = form.querySelector('select[name="user-profession"]');
        const userTypeField = form.querySelector('select[name="user-type"]');
        const erpCodeField = form.querySelector('input[name="erp-code"]');

        if (professionField) {
            professionField.addEventListener('change', (event) => {
                toggleConditionalFields(event.target, [userTypeField, erpCodeField], 'signup');
            });
        }
	});

    profileForm.forEach((form) => {
        form.addEventListener("submit", (event) => {
            form.classList.add('submitting');
        });


        const professionField = form.querySelector('select[name="user-profession"]');
        const userTypeField = form.querySelector('select[name="user-type"]');
        const erpCodeField = form.querySelector('input[name="erp-code"]');

        if (professionField) {
            professionField.addEventListener('change', (event) => {
                toggleConditionalFields(event.target, [userTypeField, erpCodeField], 'profile');
            });
        }
    });
});

function toggleConditionalFields(professionField, conditionalFields, context) {
    const selectedValue = professionField.value;
    const isLucePlanWorld = selectedValue === 'luceplan_world';
    
    conditionalFields.forEach(field => {
        if (isLucePlanWorld) {
            field.setAttribute('required', 'required');

            if ('signup' == context) {
                field.classList.add("wpcf7-validates-as-required");
                field.setAttribute('aria-required', true);
            }

            if (field.closest(".form-field")) {
                field.closest(".form-field").style.display = '';
            }
        } else {
            field.removeAttribute('required');
            field.classList.remove("wpcf7-validates-as-required");
            field.removeAttribute('aria-required');
            field.value = '';
            
            if (field.closest(".form-field")) {
                field.closest(".form-field").style.display = 'none';
            }
        }
    });
}


